import { urls } from '@app/urls';
import type { ComponentType } from '@wiseed/wikit';
import { ButtonText } from '@wiseed/wikit';
export default ($t: (string) => string, $page: any): ComponentType[] => {
	return [
		{
			component: ButtonText,
			props: {
				props: {
					label: $t('nav.header.investors.howToInvest'),
					href: urls.INVESTORS.HOW_TO_INVEST,
					classNames: $page.url.pathname === urls.INVESTORS.HOW_TO_INVEST ? 'selected' : ''
				}
			}
		},
		{
			component: ButtonText,
			props: {
				props: {
					label: $t('nav.header.investors.whyInvest'),
					href: urls.INVESTORS.WHY_INVEST,
					classNames: $page.url.pathname === urls.INVESTORS.WHY_INVEST ? 'selected' : ''
				}
			}
		},
		{
			component: ButtonText,
			props: {
				props: {
					label: $t('nav.footer.projects.psfp'),
					href: urls.PROJECTS.PSFP,
					classNames:
						$page.url?.pathname.startsWith(urls.PROJECTS.INDEX) &&
						urls.PROJECTS.PSFP.includes($page.url?.pathname)
							? 'selected'
							: ''
				}
			}
		},
		{
			component: ButtonText,
			props: {
				props: {
					label: $t('nav.footer.projects.private'),
					href: urls.PROJECTS.PRIVATE,
					classNames:
						$page.url?.pathname.startsWith(urls.PROJECTS.INDEX) &&
						urls.PROJECTS.PRIVATE.includes($page.url?.pathname)
							? 'selected'
							: ''
				}
			}
		},
		{
			component: ButtonText,
			props: {
				props: {
					label: $t('nav.footer.legal.riskWarning'),
					href: urls.LEGAL.RISK_WARNING,
					classNames: $page.url.pathname === urls.LEGAL.RISK_WARNING ? 'selected' : ''
				}
			}
		},
		{
			component: ButtonText,
			props: {
				props: {
					label: $t('nav.header.investors.help'),
					href: urls.INVESTORS.HELP,
					hrefTarget: 'blank'
				}
			}
		}
	];
};
